import { createContext } from "react";

export const GodEyeContext = createContext(null)